<template>
  <canvas :id="id" ref="canvas" class="chart-canvas" :height="height"></canvas>
</template>

<script>
import Chart from "chart.js/auto"

export default {
  name: "DoughnutChart",
  props: {
    id: { type: String, default: "doughnut-chart" },
    height: { type: [String, Number], default: 300 },
    chart: { type: Object, required: true }
  },
  mounted() {
    this.render()
  },
  watch: {
    chart: { deep: true, handler() { this.render() } }
  },
  methods: {
    render() {
      const ctx = this.$refs.canvas.getContext("2d")
      const existing = Chart.getChart(this.$refs.canvas)
      if (existing) existing.destroy()

      const ds = Array.isArray(this.chart.datasets) ? this.chart.datasets : [this.chart.datasets]
      const palette = ["#2152ff", "#ff4d4f", "#3A416F", "#a8b8d8", "#cb0c9f"]
      ds.forEach((d, i) => {
        d.backgroundColor = d.backgroundColor || (Array.isArray(d.data) ? d.data.map((_, j) => palette[j % palette.length]) : palette[i % palette.length])
        d.borderWidth = d.borderWidth ?? 2
      })

      new Chart(ctx, {
        type: "doughnut",
        data: { labels: this.chart.labels || [], datasets: ds },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "60%",
          plugins: { legend: { display: false } }
        }
      })
    }
  }
}
</script>
